import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Ref, ref, computed } from "vue";
import SpecialCaseSelectModal from "@/components/DailyReportUpdateModalParts/SpecialCaseSelectModal.vue";
import IgnoreLongTimelongContinuousWarning from "@/components/DailyReportUpdateModalParts/IgnoreLongTimelongContinuousWarning.vue";
import UnexpectedEventModals from "@/components/DailyReportUpdateModalParts/UnexpectedEventModals.vue";
import DeliveryPlan from "@/types/DeliveryPlan";
import { UNEXPECTED_EVENT_KEY, SPECIAL_EXTENSION_KEY } from "@/services/consts"


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecialCaseModals',
  props: {
    modelValue: { type: Boolean },
    deliveryPlan: {},
    createAuthority: { type: Boolean },
    showFlash: { type: Function }
  },
  emits: ['update:modelValue', 'openModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const unexpectedEventModalStatus: Ref<boolean> = ref(false)
const ignoreLongTimelongContinuousWarningModalStatus: Ref<boolean> = ref(false)

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function openModal(key: string) {
  modelValue.value = false
  if (key == SPECIAL_EXTENSION_KEY) {
    ignoreLongTimelongContinuousWarningModalStatus.value = true;
  }
  if (key == UNEXPECTED_EVENT_KEY) {
    unexpectedEventModalStatus.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SpecialCaseSelectModal, {
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      onOpenModal: openModal
    }, null, 8, ["modelValue"]),
    _createVNode(UnexpectedEventModals, {
      modelValue: unexpectedEventModalStatus.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unexpectedEventModalStatus).value = $event)),
      deliveryPlan: props.deliveryPlan,
      createAuthority: props.createAuthority,
      showFlash: props.showFlash
    }, null, 8, ["modelValue", "deliveryPlan", "createAuthority", "showFlash"]),
    _createVNode(IgnoreLongTimelongContinuousWarning, {
      modelValue: ignoreLongTimelongContinuousWarningModalStatus.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ignoreLongTimelongContinuousWarningModalStatus).value = $event)),
      deliveryPlanId: props.deliveryPlan.delivery_plan_id,
      createAuthority: props.createAuthority,
      showFlash: props.showFlash
    }, null, 8, ["modelValue", "deliveryPlanId", "createAuthority", "showFlash"])
  ], 64))
}
}

})